import './date-picker';
import spaBooking from './spa-booking';
import './status-message';

module.exports = {
    template: '#spa-booking-container',
    components: {
      spaBooking
    }
}
